<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-confirm-modal"
      data-bs-toggle="modal"
      data-bs-target="#bottom_modal_share_profile"
    ></button>
    <div class="modal modal-bottom fade" id="bottom_modal_share_profile" tabindex="-1" role="dialog"
      aria-labelledby="bottom_modal_share_profile" style="z-index: 10000;">
      <div class="modal-dialog" role="document">
        <!-- MBR theme 2 bottom sheet (same shape as ModalConfirmDeactivateMember) -->
        <div class="modal-content mbr-cf">
          <div class="mbr-cf__top">
            <span class="mbr-cf__handle" aria-hidden="true"></span>
            <!-- keep .btn-close-confirm-modal: views close this sheet with $('.btn-close-confirm-modal').click() -->
            <button type="button" class="btn-close-confirm-modal mbr-cf__close" data-bs-dismiss="modal" :aria-label="$t('common.close')">
              <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>
          <div class="modal-body mbr-cf__body">
            <p class="mbr-cf__message">{{ message }}</p>
          </div>
          <div class="mbr-cf__actions">
            <!-- keep .close-model: clicked through jQuery -->
            <button type="button" class="mbr-cf__btn mbr-cf__btn--ghost close-model" data-bs-dismiss="modal">
              {{ $t('common.no') }}
            </button>
            <button type="button" class="mbr-cf__btn mbr-cf__btn--primary" @click="sycnProfile">
              {{ btnYes }}
            </button>
          </div>
        </div>
      </div>
      <button class="btn-share-profile-modal" style="display: none" data-bs-toggle="modal"
        data-bs-target="#bottom_modal_share_profile">Success</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExchangeStatus",
  props: {
    id: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
    btnYes: {
      type: String,
      default: "",
    },
    sycnProfile: {
      type: Function,
      default: () => { },
    },
  },
};
</script>
<style scoped>
/* MBR theme 2 confirm sheet. Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-cf {
  padding: 12px 24px 28px;
  background: var(--mbr-color-surface);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
}

.mbr-cf__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-cf__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

.mbr-cf__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
}

.mbr-cf__close svg {
  width: 16px;
  height: 16px;
}

.modal.modal-bottom .modal-body.mbr-cf__body {
  padding: 12px 0 28px;
}

.mbr-cf__message {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: var(--mbr-headline-sm-weight);
  line-height: 26px;
  text-align: center;
  color: var(--mbr-color-ink-headline);
}

.mbr-cf__actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* min-height: long btnYes copy (Profile "Yes, sycn my profile") wraps inside the pill */
.mbr-cf__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 8px 20px;
  line-height: 1.25;
  text-align: center;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 16px;
  font-weight: 700;
  transition: transform 0.15s ease;
}

.mbr-cf__btn:active {
  transform: scale(0.98);
}

.mbr-cf__btn--ghost {
  background: transparent;
  border: 1.5px solid var(--mbr-color-outline);
  color: var(--mbr-color-ink-headline);
}

.mbr-cf__btn--primary {
  background: var(--mbr-color-primary);
  border: 1.5px solid var(--mbr-color-primary);
  color: var(--mbr-color-on-primary);
  box-shadow: var(--mbr-shadow-card);
}

/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: none;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: none;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--mbr-color-surface);
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}

.btn-close {
  font-size: 25px;
  color: #222 !important;
}

.btn-close span {
  color: #222;
}

</style>
